module.exports = __webpack_public_path__ + "media/LandingPageAssets/turtle_price_table_web-cc4a5290.png";